import type { AxiosRequestConfig } from 'axios'

import { CustomError } from '@front/type/api/customError'

import { AxiosInstance } from '../axios.instance'
import { NoInterceptorAxiosInstance } from '../axios-without-interceptor.instance'

export const axiosPost = async <TResult>(
  url: string,
  body: unknown,
  config?: AxiosRequestConfig<unknown>,
): Promise<TResult> => {
  try {
    const result = await AxiosInstance.post<TResult>(url, body, config)
    return result.data
  } catch (error) {
    throw new CustomError(
      error.response.status,
      error.response.data.message,
      error.response.data.payload,
      error.response.data.error,
    )
  }
}

export const axiosPostWithoutInterceptor = async <TResult>(
  url: string,
  body: unknown,
  config?: AxiosRequestConfig<unknown>,
): Promise<TResult> => {
  try {
    const result = await NoInterceptorAxiosInstance.post<TResult>(
      url,
      body,
      config,
    )
    return result.data
  } catch (error) {
    throw new CustomError(
      error.response.status,
      error.response.data.message,
      error.response.data.payload,
      error.response.data.error,
    )
  }
}
